const BASE_URL = process.env.NODE_ENV === 'development'
  ? 'http://127.0.0.1:6066/api'
  : '/api'

async function request(path, options = {}) {
  const response = await fetch(`${BASE_URL}${path}`, options)

  let data = null
  const contentType = response.headers.get('content-type')
  if (contentType && contentType.includes('application/json')) {
    data = await response.json()
  }

  if (!response.ok) {
    const message = (data && (data.error || data.message)) || `请求失败 (${response.status})`
    throw new Error(message)
  }

  return data
}

export function getAccount(uuid) {
  return request(`/getAccount?uuid=${encodeURIComponent(uuid)}`, {
    method: 'GET'
  })
}

/** GET /api/emails?uuid=xxx → 邮件列表 */
export function getEmails(uuid) {
  return request(`/emails?uuid=${encodeURIComponent(uuid)}`, {
    method: 'GET'
  })
}

/** GET /api/email?uuid=xxx&id=邮件ID → 邮件详情 */
export function getEmail(uuid, id) {
  return request(`/email?uuid=${encodeURIComponent(uuid)}&id=${encodeURIComponent(id)}`, {
    method: 'GET'
  })
}
